/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  setPriceTypeDataChangeTried,
  setPriceTypeSuccessMessage,
} from '../store/action';
import PriceTypeCustomCheckbox from './PriceTypeCustomCheckbox';
import PriceTypeCustomTextField from './PriceTypeCustomTextField';
import { tableHeadPriceType } from './tableHead';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const PriceTypeTable = ({
  rebatePriceSerchResult,
  fullScreen,
  setFullScreen,
  isReadOnly,
}) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const handleBlur = () => {
    dispatch(setPriceTypeDataChangeTried(Math.random()));
    dispatch(setPriceTypeSuccessMessage(''));
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.priceTypeCd;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ PRICE_TYPE_CD: selectedRow });
    }
  };

  return (
    <div
      className={`table-container fourRecords no-border mt-${
        fullScreen ? 3 : 5
      }`}
    >
      <Grid
        gridHeight={fullScreen ? '100vh' : 400}
        rowData={rebatePriceSerchResult}
        defaultCol={{ editable: false }}
        columnDefs={tableHeadPriceType}
        frameworkComponents={{
          customCheckboxRenderer: (props) => (
            <PriceTypeCustomCheckbox
              {...props}
              validateBtnDisable={handleBlur}
              disabled={isReadOnly}
            />
          ),
          textFieldComponent: (props) => (
            <PriceTypeCustomTextField
              {...props}
              validateBtnDisable={handleBlur}
              disabled={isReadOnly}
            />
          ),
        }}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        data-testid="onEditingStopped"
        fileName="Price Type"
        handleViewHistory={handleViewHistory}
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PRICE_TYPE_CD"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};

export default PriceTypeTable;
